import { usePageContext } from '~components/PageDataProvider/PageDataProvider';
import GridNeo from '~components/_layout/GridNeo/GridNeo';
import { getPpccParamValueByNameAndPage } from '~globals/common';
import useAllianceData from '~hooks/useAllianceData';
import { useAppSelector } from '~hooks/useRedux';

export default function PersonalCodeBanner() {
    const { ppccPageCode } = usePageContext();
    const allianceId = useAppSelector((state) => state.global.allianceId);
    const [allianceResponse, status] = useAllianceData(allianceId);

    if (status === 'loading' || status === 'pending') {
        return null;
    }

    if (status === 'error') {
        console.log('allID loading error');
        return null;
    }

    if (!allianceResponse.partnerAllianceInfo) {
        console.log('allID did not return partner data');
        return null;
    }

    const pageConfigs = allianceResponse.partnerAllianceInfo.landingPageConfigs || [];

    const bannerText =
        getPpccParamValueByNameAndPage({
            pageCode: ppccPageCode,
            pageConfigs,
            paramName: 'banner_text',
        }) ??
        `${
            allianceResponse.partnerAllianceInfo.allianceData.partnerDisplayName ||
            'Your healthcare provider'
        } and eHealth have teamed up to help you find the Medicare plan that fits you best.`;

    return (
        <section className="py-8 md:py-10 lg:py-12">
            <GridNeo>
                <div className="col-span-full lg:col-span-10 lg:col-start-2 flex justify-center text-center font-bold text-xl md:text-32 md:leading-10 text-black">
                    {bannerText}
                </div>
            </GridNeo>
        </section>
    );
}
